import React from 'react';
import {injectIntl} from 'react-intl';

export class CurrentLocale extends React.Component {
    static instance = null;

    constructor(props) {
        super(props);

        if (!CurrentLocale.instance)
            CurrentLocale.instance = this;
    }

    render() {
        return false;
    }
}

export default injectIntl(CurrentLocale);

export function intl() {
    return CurrentLocale.instance.props.intl;
}

export function formatMessage(...args) {
    return intl().formatMessage(...args);
}
